import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-zinc-900 border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="text-2xl font-bold mb-4">
              <span className="text-zinc-100">Alin</span>
              <span className="text-zinc-400">side</span>
              <span className="text-zinc-100">out</span>
            </div>
            <p className="text-zinc-400 text-sm">
              Premium mobile detailing services delivered to your doorstep.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-zinc-100 font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-zinc-400 hover:text-zinc-100 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-zinc-400 hover:text-zinc-100 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-zinc-400 hover:text-zinc-100 transition-colors">
                  Book Now
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-zinc-400 hover:text-zinc-100 transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/admin/login" className="text-zinc-400 hover:text-zinc-100 transition-colors">
                  Admin
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-zinc-100 font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li>Basic Detail</li>
              <li>Premium Detail</li>
              <li>Luxury Detail</li>
              <li>Add-On Services</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-zinc-100 font-semibold mb-4">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center text-zinc-400">
                <Phone className="w-4 h-4 mr-2" />
                +351 96 98 52 004
              </li>
              <li className="flex items-center text-zinc-400">
                <Mail className="w-4 h-4 mr-2" />
                info@alinsideout.com
              </li>
              <li className="flex items-start text-zinc-400">
                <MapPin className="w-4 h-4 mr-2 mt-1" />
                Algarve, Portugal
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-zinc-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-zinc-500">
          <p>© 2024 Alinsideout. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="hover:text-zinc-300 transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-zinc-300 transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
